import angular from 'angular';

export const inlinemanual = () => ({
    controller($scope, EnvSettings) {
        if (EnvSettings.Inlinemanual) {
            window.inlineManualOptions = { language: 'en' };

            let e = document.createElement('script');
            let t = document.getElementsByTagName('script')[0];

            e.async = 1;
            e.src = 'https://inlinemanual.com/embed/player.1e4a9d5b45d14836a3812529157bc89f.js';
            e.charset = 'UTF-8';

            t.parentNode.insertBefore(e, t);
        }
    },
});

angular
    .module('TALENYA-FE')
    .directive('inlinemanual', inlinemanual);
